/* -------------------------------------------------------------------------- *
 * Events *
 * -------------------------------------------------------------------------- *
 * Events is a pub/sub eventbus that modules can use to communicate events and
 * data between each other.
 */

const events_arr = [];

/* ------------- *
 * Module Export *
 * ------------- */

const Events = {
    /* ------------- *
     * Publish Event
     * ------------- *
     * Calls all functions within the specified event array
     * @param {string} event: The name of the event being published
     * @param {object} data: The data passed to the subscribed function(s)
     */

    publish(event, data) {
        if (events_arr[event]) {
            // Pass the data parameter to each subscribed function
            events_arr[event].forEach((subscriber) => {
                subscriber(data);
            });
        } else {
            throw new Error(`No matches found for the ${event} event.`);
        }
    },

    /* ------------------ *
     * Subscribe to Event
     * ------------------ *
     * Adds a function to the array for the specified event
     * @param {string} event: Name of the event being subscribed to
     * @param {function} fn: The function to call when the event is published
     */

    subscribe(event, fn) {
        if (typeof fn === 'function') {
            events_arr[event] = events_arr[event] || [];
            if (events_arr[event].indexOf(fn) === -1) {
                events_arr[event].push(fn);
            } else {
                throw new Error(`${fn.name} is already subscribed to the ${event} event.`);
            }
        } else {
            throw new Error(`${typeof fn}s cannot be subscribed to events.`);
        }
    },

    /* ---------------------- *
     * Unsubscribe from Event
     * ---------------------- *
     * Removes a function from the array for the specified event
     * @param {string} event: Name of the event being subscribed to
     * @param {function} fn: The function to remove from the subscriber array
     */

    unsubscribe(event, fn) {
        if (events_arr[event]) {
            const subscriber_arr = events_arr[event];
            const subscriber = subscriber_arr.indexOf(fn);

            if (subscriber !== -1) {
                subscriber_arr.splice(subscriber, 1);
            } else {
                throw new Error(`${fn.name} is not subscribed to the ${event} event.`);
            }
        } else {
            throw new Error(`No matches found for the ${event} event.`);
        }
    },
};

export default Events;
